var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50935 11.0625C8.41099 12.1609 6.6302 12.1609 5.53186 11.0625L3.52438 9.05437C3.1735 8.69106 3.1735 8.11509 3.52438 7.75178C3.88409 7.37936 4.47759 7.36904 4.85001 7.72875L6.57562 9.45437L6.5625 0.9375C6.5625 0.419736 6.98224 0 7.5 0C8.01776 0 8.4375 0.419736 8.4375 0.9375L8.45188 9.46811L10.1913 7.72937C10.1988 7.72157 10.2065 7.71387 10.2143 7.70634C10.5867 7.34663 11.1802 7.35694 11.5399 7.72937C11.8996 8.10179 11.8893 8.69528 11.5169 9.05499L9.50938 11.0625L9.50935 11.0625ZM13.125 9.99999C13.125 9.48223 13.5447 9.06249 14.0625 9.06249C14.5803 9.06249 15 9.48223 15 10V12.8694C14.9986 14.0455 14.0455 14.9986 12.8694 15H2.13061C0.954492 14.9986 0.00137695 14.0455 0 12.8694V9.99999C0 9.48223 0.419736 9.06249 0.9375 9.06249C1.45526 9.06249 1.875 9.48223 1.875 9.99999V12.8694C1.87532 13.0104 1.98958 13.1246 2.13061 13.125H12.8694C13.0104 13.1246 13.1246 13.0104 13.125 12.8694V9.99999Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion11);
export default __webpack_public_path__ + "static/media/Union (11).ed54ccfeb88424af9fa2176d25e97b99.svg";
export { ForwardRef as ReactComponent };